module.exports = __webpack_public_path__ + "static/media/carol.6e46e07d.png";